export function currencyFromPrice(price: number): string {
  return `$${(price * 0.01).toLocaleString('en-us', { minimumFractionDigits: 2 })}`;
}
